import React from 'react';
import * as Styled from '../ProductCard.styles'; // Setting loading to 1 fixes non-boolean attribute error

var ProductImageSkeleton = function ProductImageSkeleton(_ref) {
  var _ref$height = _ref.height,
      height = _ref$height === void 0 ? 360 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 270 : _ref$width,
      _ref$primaryColor = _ref.primaryColor,
      primaryColor = _ref$primaryColor === void 0 ? '#f3f3f3' : _ref$primaryColor,
      _ref$isPortrait = _ref.isPortrait,
      isPortrait = _ref$isPortrait === void 0 ? false : _ref$isPortrait,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? 1 : _ref$loading,
      _ref$minHeight = _ref.minHeight,
      minHeight = _ref$minHeight === void 0 ? isPortrait ? 136 : 100 : _ref$minHeight;
  return /*#__PURE__*/React.createElement(Styled.ImageContainer, {
    loading: loading,
    isPortrait: isPortrait
  }, /*#__PURE__*/React.createElement(Styled.ImageSkeleton, {
    height: height,
    width: width,
    color: primaryColor,
    minHeight: minHeight
  }));
};

export default ProductImageSkeleton;